import React from 'react';
import {
  FDBodyText, FDBox,
  FDContentContainer, FDStack, FDSecondaryActionButton,
} from '@facet-wealth/design';
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Legend,
} from 'recharts';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import fr from 'facet-rest';
import PlannerSummaryLayout from './PlannerSummaryLayout';

export const metaOverride = buildFacetDesignOverride()
  .nameOverride(['agentName', 'noModelAssignedCount', 'modelsDoNotMatchCount', 'inTradingCount'], {
    _component: () => FDBodyText,
    _customProps: {
      size: 'md',
    },
  }, overrideReadOnly)
  .done();


const Layout = () => {
  const theme = useTheme();
  const { resource } = useMetaLayoutContext();
  const { loadPageContentLink } = usePageContentContext();
  const plannerSummaries = resource.attr('modelUpdateRequestPlannerSummary') || [];

  // Create data for the donut chart
  const CHART_DATA = [
    {
      value: parseInt(resource.attr('noModelAssignedPercentage'), 10),
      name: `${resource.attr('noModelAssignedPercentage')} ${resource.metaField('noModelAssignedPercentage').attr('prompt')}`,
      color: theme.palette.facet.facetDesignErrorMain,
    },
    {
      value: parseInt(resource.attr('modelsDoNotMatchPercentage'), 10),
      name: `${resource.attr('modelsDoNotMatchPercentage')} ${resource.metaField('modelsDoNotMatchPercentage').attr('prompt')}`,
      color: theme.palette.facet.facetDesignWarningMain,
    },
    {
      value: parseInt(resource.attr('inTradingPercentage'), 10),
      name: `${resource.attr('inTradingPercentage')} ${resource.metaField('inTradingPercentage').attr('prompt')}`,
      color: theme.palette.facet.facetDesignSuccessMain,
    },
  ];

  return (
    <FDContentContainer maxWidth={'md'}>
      <FDStack direction={'column'} alignItems={'stretch'} spacing={3} paddingY={2}>
        <MetaControlField attr="title" />
        <MetaControlField attr="subtitle" />
        <FDStack>
          <FDStack flex={1} direction={'column'} alignItems={'center'}>
            <FDBox height={'300px'} width={'300px'}>
              <ResponsiveContainer aspect={1}>
                <PieChart>
                  <Pie
                    data={CHART_DATA}
                    dataKey="value"
                    cx="50%"
                    cy="50%"
                    innerRadius={90}
                    outerRadius={125}
                    legendType="plainline"
                    startAngle={90}
                    endAngle={450}
                    strokeWidth={2}
                  >
                    {CHART_DATA.map((entry) => (
                      <Cell key={entry.name} fill={entry.color} />
                    ))}
                  </Pie>
                  <Legend
                    wrapperStyle={{ fontSize: 12, fontWeight: 'bold' }}
                    align="center"
                    verticalAlign="middle"
                    layout="vertical"
                  />
                </PieChart>
              </ResponsiveContainer>
            </FDBox>
            {resource.withRelationship(
              fr.relationships.allItems.name,
              (rel) => (
                <FDBox width={'300px'}>
                  <FDSecondaryActionButton
                    label={rel.meta('prompt') || 'View All'}
                    onClick={() => loadPageContentLink(rel.link('related'))}
                    isFullWidth
                  />
                </FDBox>
              ),
              () => null,
            )}
          </FDStack>
          <FDStack spacing={3} direction={'column'} flex={1.25} paddingY={2}>
            <MetaCollectionRenderer
              collection={plannerSummaries}
              layout={PlannerSummaryLayout}
              metaOverrideSet={metaOverride}
            />
          </FDStack>
        </FDStack>
      </FDStack>
    </FDContentContainer>
  );
};

Layout.defaultProps = {};
Layout.propTypes = {};

export default Layout;
